<template>


  <v-form
    ref="frmAppointment"
    v-model="isValid"
  >

    <v-container
      class="pa-0 ma-0 " 
      style="height: 500px; overflow-y: auto;"               
      >        

        <v-row
          class="ma-0 px-0 pb-0 align-center"
        >
          <v-col cols="6"
              class="pa-0 ma-0"
          >

          <v-text-field light flat dense
              class="fs-18 pt-1 pr-1"
              label="Name"
              background-color="ycmd-very-lightest-gray"
              v-model="localName" 
              :rules="requiredRules"
              ref="txtFilterName"
              hide-details
              :disabled="disabled"
              />

          </v-col>
          
          <v-col cols="6"
              class="pa-0 ma-0"
          >
            <v-select
                flat
                dense                    
                :useIcon="false"
                label="Owner"
                :items="owners"
                v-model="localOwner"
                item-value="id"
                item-text="name"   
                class="pt-2 "   
                hide-details
                style="max-width: 565px;"
                background-color="ycmd-very-lightest-gray"
                :disabled="disabled"
            >
            </v-select>
            
          </v-col>

        </v-row>

  
        <v-row
          class="ma-0 pa-0"            
        >
          <v-col cols="6"
              class="pa-0 ma-0 pr-2" 
          >
            <v-row
              class="ma-0 pa-0"            
            >
              <v-col cols="12"
                  class="pa-0 ma-0"
              >

                <label 
                  class="v-label v-label--active theme--light fs-10 pointer"
                  @click="toggleOperator('localLocationOperator')"
                >Location <span class="text-decoration-underline ycmd-dark-blue--text">{{localLocationOperator === '$nin' ? 'MUST NOT' : 'MUST'}}</span> be in:</label>

                <checkbox-list
                  :items="podLocations"
                  v-model="localSelectedFacilities"
                  labelx="Locations"
                  width="100%"
                  height="100px"
                  :chips="true"
                  :outlined="true"
                  :disabled="disabled"
                />
              </v-col>
            </v-row>
            <v-row
              class="ma-0 pa-0"            
            >
              <v-col cols="12"
                  class="pa-0 ma-0"
              >
                <v-select
                    flat
                    dense                    
                    :useIcon="false"
                    label="Patient Status"
                    :items="patientTypeList"
                    v-model="localPatientType"
                    item-value="id"
                    item-text="name"   
                    outlined  
                    class="pt-2"   
                    hide-details
                    :disabled="disabled"
                >
                </v-select>

              </v-col>
            </v-row>
            
            <v-row
              class="ma-0 pa-0"            
            >
              <v-col cols="12"
                  class="pa-0 ma-0"
              >
                <label 
                  class="v-label v-label--active theme--light fs-10 pointer"
                  @click="toggleOperator('localPatientOperator')"
                >Patient <span class="text-decoration-underline ycmd-dark-blue--text">{{localPatientOperator === '$nin' ? 'MUST NOT' : 'MUST'}}</span> be in:</label>

                <patient-search
                  v-model="localPatient"
                  :group_id="group_id"
                  :search="patientSearch"
                  :multiple="true"
                  :disabled="disabled"
                  chipColor="ycmd-very-lightest-blue"
                />

              </v-col>
            </v-row>

            <v-row
              class="ma-0 pa-0"            
            >
              <v-col cols="12"
                  class="pa-0 ma-0"
              >
                <v-checkbox
                  class="mt-n5"
                  label="Priority"
                  dense
                  v-model="localPriority"
                  hide-details
                  :disabled="disabled"

                />
              </v-col>
            </v-row>
            
            <v-row
              class="ma-0 pa-0"            
            >
              <v-col cols="12"
                  class="pa-0 ma-0"
              >

                <label 
                  class="v-label v-label--active theme--light fs-10 pointer"
                  @click="toggleOperator('localCalltypeOperator')"
                >Call Type <span class="text-decoration-underline ycmd-dark-blue--text">{{localCalltypeOperator === '$nin' ? 'MUST NOT' : 'MUST'}}</span> be in:</label>

                <checkbox-list
                  :items="callTypes"
                  v-model="localSelectedCalltypes"
                  width="100%"
                  height="100px"
                  :chips="true"
                  :outlined="true"
                  :disabled="disabled"
                />
              </v-col>
            </v-row>            



          </v-col>
          <v-col cols="6"
              class="pa-0 ma-0"
          >
            <v-row
              class="ma-0 pa-0"                 
            >
              <v-col cols="12"
                  class="pa-0 ma-0"
              >
                <label 
                  class="v-label v-label--active theme--light fs-10 pointer"
                >Message Fields</label>

                <template
                  v-for="field in allMessageFields"
                >
                <message-field
                  v-model="messageAnswers[field.id]"
                  :field="field"
                  :includeOperator="true"
                  :key="`mf_${field.id}`"
                  :operator.sync="messageOperators[field.id]"
                  :disabled="disabled"
                />
                </template>
              </v-col>

            </v-row>  
          </v-col>     
        </v-row>       


        <v-row
          class="ma-0 pa-0" 
          v-if="showButtons"      
        >
          <v-col cols="12"
              class="pa-0 ma-0"
          >
          
            <v-btn
              text
              @click="cancel()"
              class="float-right"
            >
              Cancel
            </v-btn>              

            <v-btn
              text
              @click="save()"
              class="float-right"
            >
              Save
            </v-btn>  
          </v-col>
        </v-row>    
     
    </v-container>
  </v-form>
            
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import checkboxList from '@/components/checkbox-list'
import messageField from '@/components/message-field'
import scheduleSearchPatient from '@/views/apps/scheduling-new/components/scheduleSearchPatient';
  export default {
    props: {
      filter: {
          type: Object,
          default: () => {}
      },  
      pod: {
          type: Object,
          default: () => {}
      },   
      showButtons: {
          type: Boolean,
          default: false
      },
      reload: {
          type: String,
          default: ''
      },      
      group_id: {
          type: String,
          default: ''
      }, 
      messageFields: {
        type: Array,
        default: () => []
      },
      disabled: {
          type: Boolean,
          default: false
      },                                       
    },
    components: {
      'checkbox-list': checkboxList,
      'message-field': messageField,
      'patient-search': scheduleSearchPatient
    },    
    data: () => ({
      name: '',
      rules: {
          required: value => !!value || 'Required.',
          arrayRequired: (value) => {
            return !value ||  !value.length ? 'Required.' : true
          },
          shiftRules: []
      },
      isValid: true,
      localSelectedFacilities: [],
      localLocationOperator: '$in',
      localName: '',
      localPatientType: '',
      localPatient: null,
      localPatientOperator: '$in',
      localPriority: false,      
      initializing: false,
      localSelectedCalltypes: [],
      localCalltypeOperator: '$in',
      localOwner: '',
      validation_rules: {
        required: value => !!value || 'Required.',
      },
      patientTypeList: [
          {
              name: 'Established',
              id: 'established'
          },
          {
              name: 'New',
              id: 'new'
          },
          {
              name: 'Any',
              id: ''
          }
      ],
      patientSearch: '',
      messageAnswers: {},
      messageOperators: {}

     }),
    mounted() {

      setTimeout(() => {
        this.$refs['txtFilterName'].focus()
      }, 300);
    },
    methods: {
      ...mapGetters('schedule',['getFacilityById','getCallTypes']),
           
      toggleOperator (property) {
        if (this.disabled) {
          return 
        }
        let value = this[property]

        let newValue = value === '$nin' ? '$in' : '$nin'

        this.$set(this, property, newValue)

      },
      getValue(field) {

        let ff = this.filterFields[field.id]
        if (ff && ff.value_json) {
          return ff.value_json
        }
        return null
      },
      cancel() {
        this.$emit('cancel')
      },
      save() {
        this.$emit('save')
      },
      saveFilter(params) {
        this.localFilterId = params.filter_id
      },
      sendChanged(params) {
        if (!this.initializing) {
          this.$emit('changed', params)
        }
      },
      translateOperator (operator) {
        switch (operator) {
          case '$in':
          case '$eq': //We will set these based on the number of locations
            return '$in'
          case '$nin':
          case '$neq': //We will set these based on the number of locations
            return '$nin'
        }
        return null
      },
      setLocalFilter(newValue) {

        let value
        this.localPatientType = ''
        this.messageAnswers = {}
        this.messageOperators = {}

        if (newValue) {
          
          if (newValue.default_options) {
            newValue.default_options.map(option => {
              value = null
              switch (option.id) {
                case 'location': 
                  let locArr = []

                  if (option.value_json) {
                    value = JSON.parse(option.value_json)

                    if (value && value.length) {
                      value.map(f => {
                        let key = f.facility
                        if (f.unit) {
                          key += `|${f.unit}`
                        }
                        locArr.push(key)      
                      })
                    }
                  }

                  this.localSelectedFacilities = locArr
                  this.localLocationOperator = this.translateOperator(option.operator)

                  break

                case 'patient_status':
                  if (option.value_json) {
                    value = JSON.parse(option.value_json)

                    this.localPatientType = value
                  }

                  break

                case 'patient':
                  if (option.value_json) {
                    value = JSON.parse(option.value_json)

                  }

                  this.localPatient = value
                  this.localPatientOperator = this.translateOperator(option.operator)

                  break

                case 'priority':
                  value = JSON.parse(option.value_json)
                  this.localPriority = value === 'yes' ? true : false

                  break

                case 'calltype':

                  if (option.value_json) {
                    value = JSON.parse(option.value_json)
                  }

                  this.localSelectedCalltypes = value
                  this.localCalltypeOperator = this.translateOperator(option.operator)

                  break
              }
            })

            let answers = {}
            let operators = {}
            if (newValue.message_fields && newValue.message_fields.length) {
              newValue.message_fields.map(f => {
                let value = JSON.parse(f.value_json)

                //this.messageAnswers[f.id] = Array.isArray(value) ? value[0] : value
                answers[f.id] = value // Array.isArray(value) ? value : [value]
                //this.$set(this.messageAnswers,f.id,Array.isArray(value) ? value[0] : value)
                operators[f.id] = this.translateOperator(f.operator)
              })

            }
            this.messageFields.map(f => {
              let value = answers[f.id]
              let operator = operators[f.id]
              this.$set(this.messageAnswers,f.id,value)
              this.$set(this.messageOperators,f.id,operator)
            })

          }

          this.localName = newValue.name

          this.localOwner = newValue.user_id        
        }
      }
    },
    computed: {
      owners () {
        let arr = []
        let group = this.$store.getters['schedule/getGroupById'](this.group_id)
        if (group) {
          arr.push({
            id: this.group_id,
            name: `${group.name} (Group)`
          })
        }
        if (this.pod) {
          arr.push({
            id: this.pod.id,
            name: `${this.pod.name} (Pod)`
          })
        }

        let providers = []
        if (group) {
          group.users.map(u => {
            if (u.roleMap['provider']) {
              providers.push({
                id: u.id,
                name: `${u.last_name}, ${u.first_name}`
              })
            }
          })
        }

        let sorted = providers.sort(function(a, b) {
          return a.name.trim().localeCompare(b.name.trim());
        });

        sorted.map(s => {
          arr.push({
            id: s.id,
            name: `${s.name} (Provider)`
          })

        })

        return arr        

      },
      callTypes () {

        let cts = this.getCallTypes()
        let arr = []
        cts.map(ct => {
          arr.push({
            id: ct.id,
            name: ct.name,
            chip: ct.name,
            chipColor:"ycmd-very-lightest-blue"
          })
        })

        return arr

      },
      filterFields () {
        let ret = {}
        if (this.filter && this.filter.message_fields && this.filter.message_fields.length) {

          this.filter.message_fields.map(f => {
            ret[f.id] = f
          })
        }

        return ret
      },
      allMessageFields() {

        //return this.messageFields
        let arr = []
        if (this.messageFields && this.messageFields.length) {
          this.messageFields.map(f => {
            let copy = JSON.parse(JSON.stringify(f))
            arr.push(copy)
          })
        }

        return arr
        /*
        let obj = this.$store.getters['schedule/getGroupById'](this.group_id)
        if (obj) {
          return obj.fields
        }
        return []
        */
      }, 
      requiredRules () {
        return [this.rules.required]
      },      
      podLocations () {
        console.log('localSelectedFacilities', this.localSelectedFacilities)
        let currentMap = {}

        if (this.localSelectedFacilities && this.localSelectedFacilities.length) {
          this.localSelectedFacilities.map(f => {
            let pieces = f.split('|')
            currentMap[pieces[0]] = true
          })
        }

        let pf = this.podFacilities

        let arr = []

        pf.map(f => {
          arr.push({
            id: f.id,
            name: f.name,
            chip: f.shortcode,
            chipColor: 'ycmd-very-lightest-blue',
            html: `<span>${f.name}</span>`
          })

          currentMap[f.id] = false

          f.units.map(u => {
              arr.push({
                id: `${f.id}|${u.shortcode}`,
                name: u.name,
                chip: `${f.shortcode} ${u.name}`,
                chipColor: 'ycmd-very-lightest-blue',
                html: `<div class="font-weight-light pl-5" >${u.name}</div>`
              })
          })
        })

        let missing = ''
        for (let id in currentMap) {
          if (currentMap[id]) {
            if (missing) {
              missing+=', '
            }
            missing+= id
          }
        }

        if (missing) {
          this.$toasted.error(`Missing Group Facilities: ${missing}`);
        }

        return arr
      },
      podFacilities () {
        let arr = []

        if (this.pod && this.pod.facility_ids && this.pod.facility_ids.length) {
          this.pod.facility_ids.map(id => {
            let fac = this.$store.getters['schedule/getFacilityById'](id)
            arr.push(fac)
          })  
          
          let sorted = arr.sort( (a,b) => {
              return a.name.localeCompare(b.name)
          })

          arr = sorted          
        }

        return arr
      },
      isNew () {
        if (this.shift && this.shift.id) {
          return false
        }
        return true
      }
                  
    },
    watch: {
      localPatient(newValue, oldValue) {

        this.sendChanged( {
          'default_options.patient.value': newValue
        })

      },
      reload (newValue, oldValue) {
        this.setLocalFilter(this.filter)            
      },
      localSelectedCalltypes (newValue, oldValue) {
        this.sendChanged( {
          'default_options.calltype.value': newValue
        })
      },

      localSelectedFacilities (newValue, oldValue) {

        this.sendChanged( {
          'default_options.location.value': newValue
        })
      },
      localName (newValue, oldValue) {
        
        this.sendChanged( {
          name: newValue
        })

      },
      localCalltypeOperator (newValue, oldValue) {

        this.sendChanged( {
          'default_options.calltype.operator': newValue
        })

      },      

      localLocationOperator (newValue, oldValue) {

        this.sendChanged( {
          'default_options.location.operator': newValue
        })

      },      
      localPatientOperator (newValue, oldValue) {

        this.sendChanged( {
          'default_options.patient.operator': newValue
        })
      },      
      localPriority (newValue, oldValue) {
        this.sendChanged( {
          'default_options.priority.value': newValue ? 'yes': 'no'
        })
      },      
      localPatientType (newValue, oldValue) {
        this.sendChanged( {
          'default_options.patient_status.value': newValue
        })
      },      
      localOwner (newValue, oldValue) {
        this.sendChanged( {
          'user_id': newValue
        })
      },      
      filter: {
          handler (newValue, oldValue) {

            this.initializing = true

            this.setLocalFilter(newValue)            
            
            setTimeout(()=> {

              this.initializing = false
            }, 500)

          }, 
          deep: true,
          immediate: true
      },
      messageAnswers: {
          handler (newValue, oldValue) {
            if (!this.initializing) {

              this.$emit('fieldChanged', newValue)
            }

          }, 
          deep: true,
          immediate: true
      },  
      messageOperators: {
          handler (newValue, oldValue) {

            if (!this.initializing) {

              this.$emit('operatorChanged', newValue)
            }

          }, 
          deep: true,
          immediate: true
      },             
      /*
      message_fields: {
          handler (newValue, oldValue) {

            this.$emit('fieldChanged', newValue)

          }, 
          deep: true,
          immediate: true
      }
      */
    }
  }
</script>

